<template>
  <v-card-text>
    <v-switch
        label="Tylko zdjęcie"
        :input-value="options.onlyPhoto"
        @change="update({onlyPhoto: $event})"
    ></v-switch>
  </v-card-text>
</template>
<script>
import options from "@/mixins/options"

export default {
  name: "photo-options",
  mixins: [ options ]
}
</script>
<style>
</style>
